import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, NavigationStart, NavigationError, Router } from '@angular/router';
import { LangService } from './services/lang.service';

import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { SctollToTopComponent } from './shared/scroll-to-top/scroll-to-top.component';
import { TranslateModule } from '@ngx-translate/core';
import { SpinnerComponent } from './shared/spinner/spinner.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    HeaderComponent,
    FooterComponent,
    SctollToTopComponent,
    TranslateModule,
    SpinnerComponent
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'DMSocialesMMC';
  isIos: boolean = false;
  showHeader = true;
  showFooter = true;
  private excludedRoutes = ['/forget-password', '/reset-password', '/activate-account'];

  private langService = inject(LangService);
  private router = inject(Router);

  constructor() {
    this.langService.initializeLang();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.showHeader = !this.excludedRoutes.includes(event.url);
        this.showFooter = !this.excludedRoutes.includes(event.url);
      }
    });
  }

  ngOnInit(): void {
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationError) {
        this.router.navigate(['/noauthorization']);
      }
    });

    const miDiv = document.getElementById('loading-init');
    if (miDiv) {
      setTimeout(() => {
        miDiv.style.transition = 'opacity 0.5s ease';
        miDiv.style.opacity = '0';
        setTimeout(() => {
          miDiv.style.display = 'none';
        }, 500);
      }, 500);
    }
  }
}